import type { Dielec, DielecUpdate, ZakazkaDetail } from "@/api/schemas";
import { pridaneHranyNaVstup } from "@/lib/pridaneHrany";

/**
 * Pomôcky na zloženie inverzného kroku pre dielce.
 *
 * Predchádzajúce hodnoty sa čítajú **zo snapshotu cache**, ktorý si
 * `useUpdateDielec.onMutate` už dnes robí kvôli optimistickému updatu —
 * takže undo nič nedopytuje a nemôže sa rozísť s tým, čo user videl.
 */

/** Dielec v zanorenej štruktúre zákazky (varianty → zostavy → dielce). */
export function najdiDielec(
  zakazka: ZakazkaDetail | undefined,
  dielecId: string,
): Dielec | undefined {
  for (const v of zakazka?.varianty ?? []) {
    for (const z of v.zostavy ?? []) {
      for (const d of z.dielce ?? []) {
        if (d.id === dielecId) return d as Dielec;
      }
    }
  }
  return undefined;
}

/**
 * Hodnoty **len tých polí**, ktoré išli do PATCH-u.
 *
 * Poslať celý dielec by prepísalo aj to, čo medzitým zmenil niekto iný,
 * a `PATCH /dielce/{id}` má navyše XOR validáciu slot/priamy materiál —
 * úplný objekt by ju vedel porušiť.
 */
export function predchadzajuceHodnoty(
  dielec: Dielec | undefined,
  data: DielecUpdate,
): DielecUpdate {
  if (!dielec) return {};
  const out: Record<string, unknown> = {};
  const zdroj = dielec as unknown as Record<string, unknown>;
  for (const kluc of Object.keys(data)) {
    out[kluc] = zdroj[kluc] ?? null;
  }
  // Pridané hrany (KOLO 169) idú späť v tvare požiadavky — odpoveď nesie
  // aj `id` a `material`, ktoré PATCH (`extra=forbid`) odmietne s 422
  if ("pridane_hrany" in data) {
    out.pridane_hrany = pridaneHranyNaVstup(dielec.pridane_hrany);
  }
  return out as DielecUpdate;
}

/** Ľudský popis dielca do tlačidla a toastu — kód, nie UUID. */
export function popisDielca(dielec: Dielec | undefined): string {
  return dielec?.kod ?? "dielca";
}
